import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DialogContent from "@mui/material/DialogContent";
import { DARK_THEME_BODY_COLOR } from "../../constants";

const ThemedDialogContent = ({ sx, children }) => {
  const darkThemeEnabled = useSelector((state) => state.darkThemeEnabled);

  return (
    <DialogContent
      sx={{
        ...sx,
        backgroundColor: darkThemeEnabled ? DARK_THEME_BODY_COLOR : "#f7f7f7",
      }}
    >
      {children}
    </DialogContent>
  );
};

export default ThemedDialogContent;
